import bowser from 'bowser';

export function identify() {
  const classNames = [];

  if (bowser.samsungBrowser) {
    classNames.push('samsung-browser');
  }

  if (bowser.ios && bowser.safari) {
    classNames.push('ios-safari');
  }

  const html = document.getElementsByTagName('html')[0];

  if (classNames.length) classNames.push('on-device');
  if (html.classList) {
    classNames.forEach((className) => {
      html.classList.add(className);
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/browser.js